import EvidenceDefinition from './EvidenceDefinition';

export default EvidenceDefinition;
